export const membershipStartingTimes: { [key: string]: string } = {
  WHEN_APPROVED: 'Hallituksen hyväksymisen jälkeen',
  BEGINNING_OF_HALF_YEAR: '1.7. alkaen',
  BEGINNING_OF_CALENDAR_YEAR: 'Seuraavan kalenterivuoden alusta'
}

export const membershipStartingTimeFormLabels: { [key: string]: string } = {
  WHEN_APPROVED:
    'Haluan, että jäsenyyteni astuu voimaan välittömästi hallituksen hyväksymisen jälkeen',
  BEGINNING_OF_HALF_YEAR: 'Haluan, että jäsenyyteni astuu voimaan 1.7 alkaen',
  BEGINNING_OF_CALENDAR_YEAR:
    'Haluan, että jäsenyyteni astuu voimaan seuraavan kalenterivuoden alusta'
}
